import moment from 'moment'

class RuleStore {
  constructor (userStore) {
    this.userStore = userStore
  }

  /**
   * Used to check wether EPL's interview date or Fee's delivery date
   * satisfy the backdating rule.
   *
   * NOTE: If backdating rule is satisfied (meaning this function returns
   * true) it means that fee can be edited otherwise it can't since the date
   * for editing has passed
   *
   * @param {Date} date can be EPL interview date or Fee delivery date
   * @returns {Boolean} is the backdating rule satisfied
   */
  isBackdatingRuleSatisfied (date) {
    if (this.canSkipBackdating()) return true
    return this.isDateInAllowedBounds(date)
  }

  canSkipBackdating () {
    return this.userStore.isAdmin()
  }

  getBackdatingStartDate () {
    const isBetween1stAnd5th =
      moment().get('date') >= 1 && moment().get('date') <= 5

    if (isBetween1stAnd5th) {
      return moment()
        .startOf('month')
        .subtract(1, 'month')
    } else {
      return moment().startOf('month')
    }
  }

  getBackdatingEndDate () {
    // skip this rule, it seems that it isn't needed
    // return moment().endOf('month')
    return null
  }

  isDateInAllowedBounds (date) {
    const startDate = this.getBackdatingStartDate()
    return moment(date).isSameOrAfter(startDate)
  }

  isDeliveryDateAffectedByBackdating (deliveryDate) {
    if (!deliveryDate) return false
    return !this.isDateInAllowedBounds(deliveryDate)
  }
}

export default RuleStore
